// generate: the booking page generator's first complete page in a visit (LIST #75).
const actions = new Set(['embed_copy', 'generate']);
// Free-tool events, sent only with analytics consent (same gate as researchEvents).
export function toolEvent(analyticsConsent: boolean, action: string, slug: string) {
  if (!analyticsConsent || !actions.has(action) || !/^[a-z0-9-]{1,100}$/.test(slug)) return null;
  return { event: `tool_${action}`, event_category: 'tools', tool_slug: slug };
}
